import React from "react";
import { Link } from "react-router-dom";
import { fmtPrice } from "@/context/CartContext";

const ProductCard = ({ product, tone = "pink" }) => {
  const bg = {
    pink: "var(--lf-pink-pale)",
    mint: "var(--lf-mint)",
    cream: "var(--lf-cream-2)",
    lav: "var(--lf-lavender)",
  }[tone] || "var(--lf-pink-pale)";

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block"
    >
      <div
        className="lf-photo-card relative overflow-hidden"
        style={{ aspectRatio: "4 / 5", background: bg }}
      >
        <img src={product.image} alt={product.name} loading="lazy" className="w-full h-full object-cover rounded-xl" />
        {product.tag && (
          <span
            className="absolute top-5 left-5 text-[10px] uppercase tracking-[0.24em] px-3 py-1.5 font-medium"
            style={{
              background: "white",
              color: "var(--lf-gold-deep)",
              borderRadius: 999,
              border: "1px solid var(--lf-gold)",
            }}
          >
            {product.tag}
          </span>
        )}
      </div>
      <div className="mt-5 flex items-baseline justify-between gap-4">
        <h3
          className="font-serif text-xl md:text-2xl leading-tight"
          style={{ color: "var(--lf-ink)", fontWeight: 500 }}
        >
          {product.name}
        </h3>
        <span className="text-sm whitespace-nowrap font-medium" style={{ color: "var(--lf-gold-deep)" }}>
          {fmtPrice(product.price)}
        </span>
      </div>
      <p className="mt-1 text-xs uppercase tracking-[0.22em]" style={{ color: "var(--lf-ink-soft)" }}>
        {product.subcategory ? `${product.category} · ${product.subcategory}` : product.category}
      </p>
    </Link>
  );
};

export default ProductCard;
